export { default } from '../components/pages/Venue';
